var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{class:[
    'inline-block',
    // Animation
    'loading-text',
    // Clip background with text
    'text-transparent',
    'bg-gradient-to-r',
    'bg-clip-text',
    // Color
    _vm.darkMode === true && 'from-canary-500 via-loading-text-canary to-canary-500',
    (_vm.darkMode === false || _vm.darkMode === 'auto') && 'from-grape-500 via-loading-text-grape to-grape-500',
    _vm.darkMode === 'auto' && 'dark:from-canary-500 dark:via-loading-text-canary dark:to-canary-500',
  ]},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }